import gql from 'graphql-tag';
import { withRouter } from 'react-router';
import { graphql } from 'react-apollo';
import { compose, withProps } from 'recompose';
import { CustomerGroupSelect, ICustomerGroupSelectProps } from './CustomerGroutSelect';

const GetCustomerGroupListQuery = gql`
  query {
    customerGroupList {
      id
      name
    }
  }
`;

export default withRouter(compose<{}, ICustomerGroupSelectProps>(
  graphql<ICustomerGroupSelectProps, any>(GetCustomerGroupListQuery, {
    name: 'customerGroupList',
    options: props => ({
      variables: {
        domain: props.match.params.eshop
      }
    })
  }),
  withProps(({ customerGroupList }: any) => {
    return {
      customerGroupList: customerGroupList.customerGroupList,
    };
  }),
)(CustomerGroupSelect));



// WEBPACK FOOTER //
// ./src/components/Others/CustomerGroupSelect/index.ts